module.exports = __webpack_public_path__ + "static/media/18ECA33.3a5263e9.jpg";